const nav = [
  { label: "本期主打", href: "#zhuanti" },
  { label: "来龙去脉", href: "#laiqu" },
  { label: "关键节点", href: "#guanjian" },
  { label: "深扒幕后", href: "#neimu" },
  { label: "更多事件", href: "#gengduo" },
];

const extra = ["关于五1吃瓜", "投稿与报料", "商务合作", "帮助中心"];

export default function Footer() {
  return (
    <footer className="bg-accent-900 text-background-100">
      <div className="mx-auto max-w-[1240px] px-4 py-14 md:px-6">
        <div className="grid gap-10 md:grid-cols-[1.3fr_0.9fr_0.9fr_1.1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 font-heading text-lg font-bold text-accent-800">
                瓜
              </span>
              <span className="font-heading text-2xl font-bold text-background-50">五1吃瓜</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-7 text-background-100/75">
              一条时间线看懂事件全貌。我们把事件详情、来龙去脉与幕后细节按时间梳理清楚，
              关键节点不错过，让你不必四处翻帖子。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-2-line", "ri-arrow-up-line", "ri-bubble-chart-line", "ri-mail-line"].map((ic) => (
                <button
                  key={ic}
                  type="button"
                  aria-label="平台入口"
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-100/25 text-background-100 transition hover:border-background-50 hover:text-background-50"
                >
                  <i className={`${ic} h-4 w-4`} />
                </button>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-background-50">内容导航</h4>
            <ul className="mt-4 space-y-3">
              {nav.map((n) => (
                <li key={n.href}>
                  <a
                    href={n.href}
                    className="cursor-pointer text-sm text-background-100/75 transition hover:text-background-50"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-background-50">关于本站</h4>
            <ul className="mt-4 space-y-3">
              {extra.map((t) => (
                <li key={t}>
                  <button
                    type="button"
                    className="cursor-pointer text-sm text-background-100/75 transition hover:text-background-50"
                  >
                    {t}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-background-50">更新订阅</h4>
            <p className="mt-4 text-sm leading-6 text-background-100/70">
              事件最新进展更新时，第一时间通知你，不迷路、不漏更。
            </p>
            <button
              type="button"
              className="mt-4 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600"
            >
              <i className="ri-notification-3-line h-4 w-4" />
              开启更新提醒
            </button>
          </div>
        </div>

        <div className="mt-12 border-t border-background-100/15 pt-5 text-xs leading-6 text-background-100/55">
          <p>
            内容说明：本站所有复盘均基于公开资料与多方信息整理，仅供信息参考与讨论，不代表官方立场；请以相关机构与权威信源发布的正式信息为准。如涉权利问题，欢迎与我们联系核实。
          </p>
        </div>

        <div className="mt-5 flex flex-col items-center justify-between gap-3 border-t border-background-100/15 pt-5 text-xs text-background-100/70 sm:flex-row">
          <p>© 2026 五1吃瓜 · 事件复盘专栏 保留所有权利</p>
          <div className="flex flex-wrap items-center gap-5">
            <span>关键词：事件详情 · 来龙去脉 · 内幕 · 关键节点</span>
            <a
              href="#top"
              className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-background-100 transition hover:text-background-50"
            >
              回到顶部
              <i className="ri-arrow-up-line h-3.5 w-3.5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}